import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NoDataPlaceholder } from '@/components/analytics/common/NoDataPlaceholder.jsx';
import { analyticsStyles } from '@/themes/commonStyles/analytics.js';
import { formatNumberWithComma } from '@/helpers/format/formatNumber.js';

const StyledSubtitleBox = styled(Box)(() => ({
    ...analyticsStyles.analyticsChartSubtitle,
    '& .MuiTypography-caption': {
        fontSize: '14px',
    },
    '& .MuiTypography-root.MuiTypography-h5': {
        fontWeight: '400',
    },
}));

export const AnalyticsChartSubtitle = ({ label, value, unit = '' }) => (
    <StyledSubtitleBox className='analytics-chart-subtitle'>
        <Typography variant='caption'>{label}</Typography>
        <Box>
            {value ? (
                <Typography variant='h5'>
                    {typeof value === 'number' ? formatNumberWithComma(value, 1) : value}
                    {unit}
                </Typography>
            ) : (
                <NoDataPlaceholder width='94px' height='28px' />
            )}
        </Box>
    </StyledSubtitleBox>
);
